import React, { Component } from "react";
import { adminService, networkErrorHelper } from "libs";
import { MTable } from "components/table";
import { Container } from "design-react-kit";
import { BoxDanger, ModalHandler, Title } from "components/misc";
import { MnemoLoading } from "components/misc";
import { NavLink } from "react-router-dom";
import { ROUTES } from "const";

class LessonLiveClassMaterialList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      payload: [],
      rndKey: 0,
    };
  }

  //--- ---
  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "id",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      { id: "progress", Header: "#", accessor: "progress" },
      {
        id: "idClass",
        Header: "ID Classe",
        accessor: "idClass",
      },
      {
        id: "courseCode",
        Header: "Codice corso",
        accessor: "courseCode",
      },
      {
        id: "folder",
        Header: "Cartella",
        accessor: "folder",
      },
      {
        id: "title",
        Header: "Titolo",
        accessor: "title",
      },
      {
        id: "description",
        Header: "Descrizione",
        accessor: "description",
      },
      {
        id: "aa",
        Header: "A.A.",
        accessor: "aa",
      },
      {
        id: "visible",
        Header: "Visibile?",
        accessor: "visible",
      },
      {
        id: "idExamSession",
        Header: "ID Sessione Esame",
        accessor: "idExamSession",
      },
    ],
    actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.location.href =
            ROUTES.LESSON_LIVE_CLASS_MATERIAL_DETAIL + "/" + value;
        },
      },
      {
        id: "delete",
        accessor: "id", // field value received in the onclick event
        label: "Elimina",
        icon: "it-delete",
        className: "MTable-actions",
        onClick: (e, value) => {
          this.deleteRecord(e, value);
        },
      },
    ],
  };
  //--- ---

  componentDidMount() {
    this.loadRemote();
  }

  loadRemote() {
    this.setState({ loading: true });

    adminService
      .loadLessonLiveClassMaterials()
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.lessonLiveClassMaterials).forEach(
          ([key, val]) => {
            //--- manage exception to render human-readable data ---
            if (val.visible) {
              val.visible = "Sì";
            } else {
              val.visible = "No";
            }
            items.push(val);
          }
        );
        //--- ---

        this.setState({
          loading: false,
          payload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
          });
        }
      });
  }

  //--- start functions to delete procedure ---
  deleteRecord(e, value) {
    ModalHandler.show(
      value,
      "Eliminazione definitiva del dato",
      "vuoi davvero eliminare?",
      null,
      this.deletePermanentlyConfirmed
    );
  }

  deletePermanentlyConfirmed = (value) => {
    adminService
      .deleteLessonLiveClassMaterial(value)
      .then(({ data }) => {
        this.setState({ loading: true });
        this.loadRemote();
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  };
  //--- end functions to delete procedure ---

  render() {
    const { loading } = this.state;

    return (
      <>
        <div className="container mt-3 mb-4">
          <section className="m-0">
            <Title>Materiale didattico</Title>
            <div className="form-row">
              <div className="col-md-12 text-right">
                <NavLink
                  to={ROUTES.LESSON_LIVE_CLASS_MATERIAL_DETAIL}
                  className="btn btn-primary bg-dark mx-1"
                >
                  Aggiungi Materiale
                </NavLink>
              </div>
            </div>
          </section>

          <hr />

          <section className="my-4">
            {loading ? (
              <MnemoLoading></MnemoLoading>
            ) : (
              <Container>
                <MTable
                  key={this.state.rndKey}
                  tableData={this.state.payload}
                  tableConfig={this.tableConfig}
                />
              </Container>
            )}

            {this.state.payload.length === 0 && (
              <BoxDanger key="nrp-1" className="my-3">
                Ricerca non valida.
                <div className="small text-info">Nessun dato disponibile.</div>
              </BoxDanger>
            )}
          </section>
        </div>
      </>
    );
  }
}

export default LessonLiveClassMaterialList;
